<template>
  <div id="couponQCode">
    <el-row>
      <el-col :span="24"
              class="titleLine">
        <el-breadcrumb separator-class="el-icon-arrow-right"
                       class="titleLine1">
          <el-breadcrumb-item>优惠券</el-breadcrumb-item>
          <el-breadcrumb-item>优惠券设置</el-breadcrumb-item>
          <el-breadcrumb-item>优惠券领用二维码</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-row>
      <el-form :inline="true"
               class="pageSearch">
        <el-form-item label="客户名称::">
          <el-select v-model="selCustID"
                     filterable
                     clearable
                     @change="setQuerySeller($event)"
                     placeholder="请选择客户">
            <el-option v-for="item in choiceCusts"
                       :key="item.fCustID"
                       :label="item.unionName"
                       :value="item.fCustID">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商户名称::">
          <el-select v-model="selSellID"
                     filterable
                     clearable
                     placeholder="请选择商户">
            <el-option v-for="item in choiceSellers"
                       :key="item.fSelID"
                       :label="'【' + item.fSelName + '】' + item.fMerName"
                       :value="item.fSelID">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="优惠券信息::">
          <el-input placeholder="请输入优惠券信息"
                    v-model="selfRemark"
                    class="input-with-select">
          </el-input>
        </el-form-item>
        <!--<el-form-item label="优惠券类型::">-->
        <!--<el-select v-model="selfTypeID"-->
        <!--filterable-->
        <!--placeholder="请选择优惠券类型类型">-->
        <!--<el-option v-for="item in statusList"-->
        <!--:key="item.fTypeID"-->
        <!--:label="item.Title"-->
        <!--:value="item.fTypeID">-->
        <!--</el-option>-->
        <!--</el-select>-->
        <!--</el-form-item>-->
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     size="small"
                     @click="couponQCodeListQuery">查询</el-button>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row>
      <el-col :span="24"
              style="height: 5px"></el-col>
    </el-row>
    <el-row>
      <el-table :data="couponQCodeList"
                border
                highlight-current-row
                style="width: 100%"
                v-loading="loading"
                :height="tableHeight"
                ref="singleTable">
        <el-table-column type="index"
                         width="50"
                         label="序号"
                         :index="indexMethod">
        </el-table-column>
        <el-table-column prop="fOpLastTimeTitle"
                         label="最后同步时间">
        </el-table-column>
        <el-table-column prop="fCustNo"
                         width="75"
                         label="客户编号">
        </el-table-column>
        <el-table-column prop="fCustName"
                         width="160"
                         label="客户名称">
        </el-table-column>
        <el-table-column prop="fMerName"
                         label="商户名称"> </el-table-column>
        <el-table-column prop="fRemark"
                         label="优惠券说明"> </el-table-column>
        <el-table-column prop="fBatStartTimeTitle"
                         label="起始时间">
        </el-table-column>
        <el-table-column prop="fBatEndTimeTitle"
                         label="结束时间">
        </el-table-column>
        <el-table-column prop="fBatUseTimeTitle"
                         label="使用时效">
        </el-table-column>
        <el-table-column prop="fCouponValueTitle"
                         label="抵扣说明">
        </el-table-column>
        <el-table-column prop="fBatNums"
                         align="right"
                         width="75"
                         label="批次数量">
        </el-table-column>
        <el-table-column prop="fCreNums"
                         align="right"
                         width="75"
                         label="生成数量">
        </el-table-column>
        <el-table-column prop="fGetNum"
                         align="right"
                         width="75"
                         label="领用数量">
        </el-table-column>
        <el-table-column prop="fUseNum"
                         align="right"
                         width="75"
                         label="已用数量">
        </el-table-column>
        <el-table-column fixed="right"
                         align="center"
                         label="操作"
                         width="240">
          <template slot-scope="scope">
            <el-button @click="qCode(scope.row)"
                       type="success"
                       size="mini"
                       v-if="is_use_coupon">固定二维码</el-button>
            <el-button @click="qDynamicCode(scope.row)"
                       type="success"
                       size="mini"
                       v-if="is_use_coupon">动态二维码</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row class="pagination">
      <el-col :span="24">
        <div class="block">
          <span class="demonstration"></span>
          <el-pagination background
                         @size-change="handleSizeChange"
                         :current-page.sync="pageNo"
                         @current-change="handlePage"
                         :page-size="pageSize"
                         :page-sizes="[10, 20, 50, 100]"
                         layout="total,sizes, prev, pager, next, jumper"
                         :total="total"
                         v-if="total > 0">
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <div class="couponQCodeEditOrDetail">
      <el-dialog title="优惠券静态二维码"
                 :visible.sync="couponQCodeVisible"
                 v-dialogDrag
                 top="7vh"
                 left="0vh"
                 width="50%">
        <template>
          <!--<el-row style="margin-bottom: 15px">-->
          <!--<el-col :span="24">-->
          <!--<el-button  @click="createQCode()"  type="success" size="medium">生成二维码</el-button>-->
          <!--</el-col>-->
          <!--</el-row>-->
          <el-row v-if="qCodeimg">
            <el-col :span="24"
                    align="center">
              <img :src="'data:image/png;base64,' + imgBase64"
                   width="430"
                   height="430"
                   id="imgDown" />
            </el-col>
          </el-row>
        </template>
        <div slot="footer"
             class="dialog-footer">
          <el-button @click="couponQCodeVisible = false">关 闭</el-button>
          <el-button @click="downloadImg('imgDown')"
                     icon="el-icon-takeaway-box"
                     type="success"
                     size="medium">保 存</el-button>
        </div>
      </el-dialog>
      <el-dialog title="优惠券动态二维码"
                 :visible.sync="couponDynamicQCodeVisible"
                 v-dialogDrag
                 top="7vh"
                 left="0vh"
                 width="50%">
        <template>
          <el-row>
            <el-col :span="24"
                    v-if="qDynamicCodeimg">
              <el-card :body-style="{ padding: '0px' }">
                <el-col :span="24"
                        align="center">
                  <el-form :inline="true"
                           style="padding-top: 10px">
                    <el-form-item label="该动态二维码有效期:: ">
                      <el-radio-group v-model="selDay"
                                      @change="setDynamicQCode">
                        <el-radio :label="1">1 天</el-radio>
                        <el-radio :label="2">2 天</el-radio>
                        <el-radio :label="3">3 天</el-radio>
                        <el-radio :label="4">其他</el-radio>
                      </el-radio-group>
                      <!--<el-radio v-model="selDay" label="1">1 天</el-radio>-->
                      <!--<el-radio v-model="selDay" label="2">2 天</el-radio>-->
                      <!--<el-radio v-model="selDay" label="3">3 天</el-radio>-->
                      <!--<el-radio v-model="selDay" label="4">其他</el-radio>-->
                    </el-form-item>
                    <el-form-item label=""
                                  v-if="selDay == '4'">
                      <el-input :change="check_num()"
                                placeholder="请输入天数"
                                v-model="inputselDay"></el-input>
                    </el-form-item>
                    <el-form-item v-if="selDay == '4'">
                      <el-button type="primary"
                                 @click="clickDyanmicQCode">生成二维码</el-button>
                    </el-form-item>
                  </el-form>
                  <el-row>
                    <div style="padding: 5px;">
                      <!--<el-select v-model="selDay"-->
                      <!--@change="setDynamicQCode($event)"-->
                      <!--filterable-->
                      <!--clearable-->
                      <!--placeholder="请选择天数">-->
                      <!--<el-option v-for="item in dayList"-->
                      <!--:key="item.value"-->
                      <!--:label="item.text"-->
                      <!--:value="item.value">-->
                      <!--</el-option>-->
                      <!--</el-select>-->
                    </div>
                  </el-row>
                  <el-row><img :src="'data:image/png;base64,' + imgDyanmicBase64"
                         width="430"
                         height="430"
                         id="imgDown2" /></el-row>
                </el-col>
              </el-card>
            </el-col>
          </el-row>
        </template>
        <div slot="footer"
             class="dialog-footer">
          <el-button @click="couponDynamicQCodeVisible = false">关 闭</el-button>
          <el-button @click="downloadImg('imgDown2')"
                     icon="el-icon-takeaway-box"
                     type="success"
                     size="medium">保 存</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { coupon as api } from '../../api/coupon'
import { mapActions } from 'vuex'
export default {
  name: 'couponQCode.vue',
  data () {
    return {
      curRowInfo: {
        op: '',
        isEdit: false,
        fBatchID: '',
        fSelName: '',
        fCustID: '',
        fCustNo: '',
        fAppSelID: '',
        fParkID: '',
        fRemark: '',
        fBatStartTime: '',
        fBatStartTimeTitle: '',
        fBatEndTimeTitle: '',
        fBatEndTime: '',
        fBatUseTime: '',
        fCouponType: '',
        fCouponValue: '',
        fBatNums: '',
        fCreNums: '',
        fGetNums: '',
        fUseNums: '',
        IsHideValue: false
      },
      is_use_coupon: true,
      qCodeimg: false,
      qDynamicCodeimg: false,
      imgBase64: '',
      imgDyanmicBase64: '',
      dayList: [],
      selDay: 1,
      inputselDay: '1',
      formLabelWidth: '120px',
      couponQCodeVisible: false,
      couponDynamicQCodeVisible: false,
      syncouponQCodeList: [],
      couponQCodeList: [],
      loading: false,
      selfTypeID: '1',
      selCustID: '',
      selfRemark: '',
      choiceCusts: [],
      selSellID: '',
      choiceSellers: [],
      sellerList: [],
      choiceCouponTypeList: [],
      parks: [{ fParkID: '0', fParkName: '所有停车场' }],
      statusList: [],
      couponQCodeActiveName: 'couponQCodeList',
      tableHeight: 0,
      pageSize: 20,
      pageNo: 1,
      total: 0,
      couponValueEnable: false
    }
  },
  methods: {
    ...mapActions(['getCustByGroup', 'getParkList']),
    check_num: function () { },
    setPark (val, isEdit) {
      this.parks = []
      this.getParkList({ fCustID: val }).then(res => {
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              this.parks = data.Data || []
            }
          }
          let all = {}
          all['fParkID'] = '0'
          all['fParkName'] = '所有停车场'
          this.parks.unshift(all)
          if (!isEdit) {
            this.curRowInfo.fParkID = '0'
          }
        }
      })
      this.sellerList = []
      this.setSellDDL(val).then(res => {
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              this.sellerList = data.Data || []
              if (this.sellerList && this.sellerList.length > 0 && !isEdit) {
                this.curRowInfo.fAppSelID = this.sellerList[0].fSelID
              }
            }
          }
        }
      })
    },
    setQuerySeller (val) {
      this.choiceSellers = []
      this.selSellID = ''
      this.setSellDDL(val).then(res => {
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              this.choiceSellers = data.Data || []
            }
          }
        }
      })
    },
    setSellDDL (val) {
      return api.getSellerListByCustIDAsync({ fCustID: val })
    },
    setDefault () {
      this.sellerList = []
      let tmp = this.curRowInfo.fCouponType
      for (let key in this.curRowInfo) {
        this.curRowInfo[key] = ''
      }
      var today = new Date()
      this.curRowInfo.fBatStartTimeTitle = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate(),
        0,
        0,
        0
      )
      this.curRowInfo.fBatEndTimeTitle = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate(),
        23,
        59,
        59
      )
      this.curRowInfo['fParkID'] = '0'
      this.curRowInfo.fCouponType = tmp
      this.curRowInfo.fCreNums = 0
      this.curRowInfo.fGetNums = 0
      this.curRowInfo.fUseNums = 0
      this.curRowInfo.IsHideValue = false
    },
    downloadImg (id) {
      var d = document.getElementById(id)
      var url = d.src
      var a = document.createElement('a')
      var event = new MouseEvent('click')
      a.download = 'CouponQCode' + new Date().getSeconds() + '.png'
      a.href = url
      a.dispatchEvent(event)
    },
    createQCode () {
      api.createQCode(this.curRowInfo).then(res => {
        let { status, data } = res
        if (status !== 200) {
          this.$message.error('提示：生成优惠券二维码出错')
        } else {
          if (!data.IsOk) {
            this.$message.error(data.Msg)
          } else {
            if (data.Data) {
              this.qCodeimg = true
              this.imgBase64 = data.Data.imgBase64 || ''
            }
          }
        }
      })
    },
    setDynamicQCode () {
      let val = this.selDay
      if (this.selDay !== 4) {
        this.createDynamicQCode(val)
      }
    },
    clickDyanmicQCode () {
      var reg = /^[1-9]\d*$/
      if (!reg.test(this.inputselDay)) {
        this.$message.error('只能是1~30天的数字')
        return
      }
      if (parseInt(this.inputselDay) > 30) {
        this.$message.error('只能是1~30天')
        return
      }
      this.createDynamicQCode(this.inputselDay)
    },
    createDynamicQCode (selDay) {
      this.curRowInfo.selDay = selDay
      api.createDynamicQCode(this.curRowInfo).then(res => {
        let { status, data } = res
        if (status !== 200) {
          this.$message.error('提示：生成动态优惠券二维码出错')
        } else {
          if (!data.IsOk) {
            this.$message.error(data.Msg)
          } else {
            if (data.Data) {
              this.qDynamicCodeimg = true
              this.imgDyanmicBase64 = data.Data.imgBase64 || ''
            }
          }
        }
      })
    },
    qDynamicCode (row) {
      this.curRowInfo.isEdit = false
      this.imgDyanmicBase64 = ''
      this.qCodeimg = false
      this.selDay = 1
      if (row && row !== null && typeof row !== 'undefined') {
        Object.assign(this.curRowInfo, row)
        this.detailTitle = '【' + row.fRemark + '】 生成动态二维码'
        this.couponDynamicQCodeVisible = true
        this.createDynamicQCode(this.selDay)
      }
    },
    qCode (row) {
      this.curRowInfo.isEdit = false
      this.imgBase64 = ''
      this.qCodeimg = false
      if (row && row !== null && typeof row !== 'undefined') {
        Object.assign(this.curRowInfo, row)
        this.detailTitle = '【' + row.fRemark + '】 生成二维码'
        this.couponQCodeVisible = true
        this.createQCode()
      }
    },
    couponQCodeListQuery () {
      this.initData()
    },
    handleSizeChange (value) {
      this.pageSize = value
      this.initData()
    },
    handlePage (index) {
      this.pageNo = index
      this.initData()
    },
    tabClick () {
      this.pageNo = 1
      this.total = 0
      this.initData()
    },
    indexMethod (index) {
      return this.pageSize * (this.pageNo - 1) + index + 1
    },
    initData () {
      var isSyn = this.couponQCodeActiveName === 'syncouponQCodeList'
      if (isSyn) {
        this.syncouponQCodeList = []
      } else {
        this.couponQCodeList = []
      }
      this.loading = true
      api.couponBatchList({
        fCustID: this.selCustID,
        fTypeID: this.selfTypeID,
        fUseStatus: this.selfTypeID,
        fAppSelID: this.selSellID,
        fRemark: this.selfRemark,
        isSync: isSyn,
        pageSize: this.pageSize,
        pageNo: this.pageNo
      })
        .then(res => {
          this.loading = false
          if (res && res.data) {
            let { status, data } = res
            if (status === 200) {
              if (data.IsOk) {
                this.couponQCodeList = data.Data.rows
                this.total = data.Data.total
              }
            } else {
              this.$message.error('提示:' + data.Msg)
            }
          }
        })
    },
    setTableHeight (obj) {
      let clientHeight = obj.getRJPageSize.getRJPageSize()[3] - 25 - 230
      obj.tableHeight = clientHeight
    }
  },
  created () {
    // user.getCurrentUserPers({ perTypeId: 200000 }).then(res => {
    //   if (res && res.data) {
    //     var data = res.data
    //     if (data.IsOk) {
    //       if (data.Data) {
    //         this.is_use_coupon = data.Data.data.is_use_coupon
    //       }
    //     } else {
    //       this.$message.error('提示：加载当前用户权限信息失败')
    //     }
    //   }
    // })
    this.initData()
  },
  mounted () {
    let sizethis = this
    window.onresize = () => {
      this.setTableHeight(sizethis)
    }
    this.statusList = [
      { fTypeID: '0', Title: '所有优惠券' },
      { fTypeID: '1', Title: '正在使用' },
      { fTypeID: '2', Title: '使用完成' }
    ]
    for (var j = 1; j <= 10; j++) {
      this.dayList.push({ text: j + '天', value: j })
    }
    this.getCustByGroup().then(res => {
      if (res && res.data) {
        let { status, data } = res
        if (status === 200) {
          if (data.IsOk) {
            let custs = []
            Object.assign(custs, data.Data)
            this.choiceCusts = custs
          }
        }
      }
    })
    api.getTypeList({}).then(res => {
      if (res && res.data) {
        let { status, data } = res
        if (status === 200) {
          if (data.IsOk) {
            Object.assign(this.choiceCouponTypeList, data.Data.CouponTypeList)
            this.curRowInfo.fCouponType = data.Data.CouponTypeList_defaultValue
          }
        }
      }
    })
  },
  updated () {
    this.setTableHeight(this)
  }
}
</script>

<style>
#couponQCode .warning-row {
  color: chocolate;
}
.couponQCodeEditOrDetail .el-dialog__title {
  color: white;
}
.couponQCodeEditOrDetail .el-dialog__header {
  background-color: #337ab7;
  padding: 10px;
}
.couponQCodeEditOrDetail .el-dialog__body {
  padding-bottom: 5px;
}
.couponQCodeEditOrDetail .el-dialog__headerbtn {
  top: 10px;
  font-size: 20px;
}
#couponQCode .el-dialog__body {
  padding: 10px 20px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
}
#couponQCode .el-form-item {
  margin-bottom: 5px;
}
</style>
<style scoped>
.pagination {
  text-align: right;
  padding-top: 5px;
}
.pageSearch .el-form-item {
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/view/coupon/couponQCode.vue